import { Box, Button, Modal, Typography } from '@mui/material';
import React from 'react';
interface CommonModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSubmit?: () => void;
  submitLabel?: string;
  submitDisabled?: boolean;
}
export const CommonModal: React.FC<CommonModalProps> = ({
  open,
  onClose,
  title,
  children,
  onSubmit,
  submitLabel = 'Add',
  submitDisabled = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', sm: '600px' },
          maxWidth: '90vw',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#4285f4',
            color: 'white',
            p: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          <Box
            onClick={onClose}
            sx={{
              cursor: 'pointer',
              fontSize: '24px',
              fontWeight: 'bold',
              '&:hover': { opacity: 0.7 },
            }}
          >
            ×
          </Box>
        </Box>

        <Box sx={{ p: 3 }}>
          {children}

          {onSubmit && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                onClick={onSubmit}
                disabled={submitDisabled}
                sx={{
                  backgroundColor: '#4285f4',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#3367d6',
                  },
                  '&:disabled': {
                    backgroundColor: '#ccc',
                    color: '#666',
                  },
                }}
              >
                {submitLabel}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};
